"use client";
// Imports
import { ComponentWrapper, Countdown, Container } from "@/components";
import { VolumeX, Volume, Play, Pause } from "lucide-react";
import { useState, useRef } from "react";
import { cn } from "@/lib/utils";

// Hero Video — full width uses reserved aspect height (same idea as HeroSlideshow)
export function HeroVideo({
  type,
  video,
  width,
  showCount,
  daysUntil,
  startDate,
  endDate,
  showStartDate,
  showStartTime,
  unformattedStartDate,
  unformattedEndDate,
}) {
  const [isMuted, setIsMuted] = useState(true);
  const [isPlaying, setIsPlaying] = useState(true);
  const videoRef = useRef();

  const widthValue = typeof width === "object" ? width?.value : width;
  const isFullWidth = widthValue === "full";
  const aspectRatio =
    video?.width && video?.height
      ? `${video.width} / ${video.height}`
      : undefined;

  // Functions
  function toggleMute() {
    const el = videoRef.current;
    if (!el) return;
    el.muted = !el.muted;
    setIsMuted(el.muted);
  }

  function togglePlay() {
    if (!videoRef.current) return;
    if (videoRef.current.paused) {
      videoRef.current.play();
      setIsPlaying(true);
    } else {
      videoRef.current.pause();
      setIsPlaying(false);
    }
  }

  const media = (
    <div className="relative w-full overflow-hidden">
      <div
        className="relative w-full"
        style={{
          width: "100%",
          ...(aspectRatio ? { aspectRatio } : {}),
        }}
      >
        <video
          ref={videoRef}
          id="video"
          className={cn(
            "absolute inset-0 h-full w-full object-cover",
            !isFullWidth && "max-h-[90dvh]"
          )}
          playsInline
          muted={true}
          loop={true}
          autoPlay={true}
          width={video?.width}
          height={video?.height}
        >
          <source src={video?.permalink} type="video/mp4" />
        </video>
        <div className="flex absolute right-4 bottom-4 z-10 justify-end space-x-5 text-white">
          <button
            className="opacity-50 lg:hover:opacity-100"
            onClick={togglePlay}
          >
            {isPlaying ? (
              <Pause color="white" size="24" />
            ) : (
              <Play color="white" size="24" />
            )}
          </button>
          <button
            className="opacity-50 lg:hover:opacity-100"
            onClick={toggleMute}
          >
            {isMuted ? (
              <VolumeX color="white" size="24" />
            ) : (
              <Volume color="white" size="24" />
            )}
          </button>
        </div>
      </div>
      <Countdown
        showCount={showCount}
        daysUntil={daysUntil}
        startDate={startDate}
        endDate={endDate}
        unformattedStartDate={unformattedStartDate}
        unformattedEndDate={unformattedEndDate}
        showStartDate={showStartDate}
        showStartTime={showStartTime}
      />
    </div>
  );

  // Render
  return (
    <ComponentWrapper type={type}>
      {isFullWidth ? (
        media
      ) : (
        <Container width={widthValue || "2xl"}>{media}</Container>
      )}
    </ComponentWrapper>
  );
}
